import React, { useEffect, useRef, useState } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Text, View, ScrollView, Image } from 'react-native'
import { request_get_wise } from '../../services/schedule.services'
import { Loader } from '../customUtils/Components/Loader'
import { Content, Wise } from '../../services/interfaces/schedule.interface/schedule.getwise.interface'
import theme from '../../../theme'
import { StoreFormItem } from './StoreFormItem'
import { FormView } from './ExecutionView'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { schedulesServices } from '../../../database/schedules.database'
import { getDb } from '../../../db-sqlite/adapter'
import {
    getOrCreateFormDayUniqueId,
    clearFormDayUniqueId,
} from '../../utils/formDayUniqueIdStore'
import { useNavigation } from '@react-navigation/native'
import styles from './WiseScreenStyles'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { FormContentsModel } from './models/StoreDetailModel'
import { eventEmitter, validateConnectionNetwork } from '../../utils/functions.utils'
import { RetryComponent } from './components/RetryComponent'
import { useFormView } from './hooks/useFormView'
import { saveFormsBatch } from '../../../db-sqlite/repositories/schedule.repository'
import { getGlobalVersion, updateGlobalVersion } from '../../../db-sqlite/repositories/user.repository'

export const WiseScreen = React.memo(() => {
    const [formsData, setformsData] = useState<Wise[] | []>([])
    const [isLoading, setIsLoading] = useState(true)
    const [selectedForm, setForm] = useState<Wise>()
    //console.log('🚀 ~ WiseScreen ~ selectedForm:', selectedForm)
    const [formType, setFormType] = useState(0)
    const [formTypeObj, setFormTypeObj] = useState(null)
    // const [formType, setFormType] = useState(0)
    const [formContent, setContents] = useState<Content[]>([])
    const { languageFile } = getLanguage()
    const formsRef = useRef(formsData)
    const navigation = useNavigation()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [reloadHideShowData, setReloadHideShowData] = useState(false)
    const [modalRetry, setModalRetry] = useState(false)
    const messageLoaderForms = 'Cargando formularios...'
    const [formReloadKey, setFormReloadKey] = useState(0)
    const { sendFormsPending } = useFormView({})
    useEffect(() => {
        formsRef.current = formsData
    }, [formsData])

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            fetchGetWise()
        })

        return unsubscribe
    }, [navigation])

    const fetchGetWise = async () => {
        let loaderClosed = false // ✅ Flag para evitar cerrar el loader múltiples veces
        
        try {
            setModalRetry(false)

            const hasTextLoop = false
            eventEmitter.emit('starGeneralLoaderCustom', messageLoaderForms, null, null, hasTextLoop)

            const hasConnection = await validateConnectionNetwork()

            if (hasConnection) {
                try {
                    sendFormsPending()
                    const session = await fetchAuthSession()
                    const authToken = session.tokens?.accessToken?.toString() || ''

                    const res = await request_get_wise({ authToken })
                    
                    let wise = res.single.wise
                    if (wise.length === 0) {
                        setIsLoading(false)
                        loaderClosed = true
                        eventEmitter.emit('endGeneralLoaderCustom')
                        setModalRetry(true)
                        return
                    }

                    let version = res.single.version
                    let newContents = wise[0].contents.map((content) => {
                        if (content.status === 3) {
                            return {
                                ...content,
                                hideQuestion: true,
                            }
                        }
                        return content
                    })
                    wise[0].contents = newContents
                    setformsData(wise)

                    if (res.single.wise && res.single.wise.length > 0) {
                        setFormType(wise[0]['type_form']['type'] ?? 0)
                        setFormTypeObj(wise[0]['type_form'])
                        setContents(wise[0].contents ?? [])
                        setForm(wise[0])
                    }
                    
                    try {
                        const versionDatabase = await getGlobalVersion('wise')
                        const shouldSave = !versionDatabase || version > versionDatabase

                        if (shouldSave) {
                            await updateGlobalVersion('wise', version)
                            const savedCount = await saveFormsBatch(wise, true)
                            console.log(`Saved ${savedCount} forms to local database (version ${versionDatabase} → ${version})`)
                            setFormReloadKey((prev) => prev + 1)
                        } else {
                            console.log(`Skipping saveFormsBatch, local version is up to date (${versionDatabase})`)
                        }
                    } catch (error) {
                        console.error('Error saving forms batch:', error)
                    }
                    
                } catch (error) {
                    console.error('Error fetching WISE from API:', error)
                    console.log('Cargando formularios desde la base de datos local debido a error en la API')
                    await getWiseLocal()
                }
                        
            } else {
                console.log('No hay conexión a la red, cargando formularios desde la base de datos local')
                await getWiseLocal()
            }
        } catch (error) {
            console.error('fetchGetWise error crítico:', error)
            try {
                await getWiseLocal()
            } catch (localError) {
                console.error('getWiseLocal también falló:', localError)
                setModalRetry(true)
            }
        } finally {
            setIsLoading(false)
            
            if (!loaderClosed) {
                eventEmitter.emit('endGeneralLoaderCustom')
            }
        }
    }

    const getWiseLocal = async () => {
        try {
            const forms_wise = await schedulesServices.getFormsWise()
            console.log('Formularios WISE obtenidos de la base de datos local:', forms_wise.length)
            let wise = forms_wise

            if (wise.length === 0) {
                console.warn('⚠️ WISE: No hay formularios en BD local')
                setModalRetry(true)
                return
            }
            let newContents = wise[0].contents.map((content) => {
                if (content.status === 3) {
                    return {
                        ...content,
                        hideQuestion: true,
                    }
                }
                return content
            })
            wise[0].contents = newContents
            if (forms_wise && forms_wise.length > 0) {
                setFormType(wise[0]['type_form']['type'] ?? 0)
                setFormTypeObj(wise[0]['type_form'])
                setContents(wise[0].contents ?? [])
                console.log('seteo wise local:', wise[0].contents[0])
                setForm(wise[0])
            }
            setformsData(wise)
        } catch (error) {
            console.error('getWiseLocal: error: ', error)
            setModalRetry(true)
            throw error // Re-lanzar para que el catch padre lo maneje
        }
    }

    const onClickForm = (index: number, forceReload = false) => {
        if (selectedForm != null && selectedForm._id === formsData[index]._id && !forceReload) {
            return
        }
        const type = formsData[index]?.type_form?.type ?? 0
        setFormType(type)
        setFormTypeObj(formsData[index]?.type_form)
        let newContents = formsData[index].contents.map((content) => {
            if (content.status === 3) {
                return {
                    ...content,
                    hideQuestion: true,
                }
            }
            return content
        })
        // setContents(formsData[index].contents ?? [])
        setContents(newContents ?? [])
        setForm(formsData[index])
    }

    const hideOrShow = (hide?: string[], show?: string[], data?: FormContentsModel[]) => {
        // console.log('====================================')
        // console.log('estoy en el hideOrShow ', data.length)
        // console.log('====================================')
        // console.log('Debería ocultar estos', hide)
        // console.log('Debería mostrar estos', show)

        let dataMap = data && data.length > 0 ? data : formContent

        const updatedFormContent = dataMap.map((question) => {
            if (hide && hide.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: true,
                }
            }
            if (show && show.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: false,
                }
            }
            return question
        })

        setContents(updatedFormContent)
        // console.log('seteo wise en 180', updatedFormContent[0])
        setReloadHideShowData(!reloadHideShowData)
    }

    const clearRegisterDatabaseLocal = async (type = null) => {
        console.log('🚀 ~ clearRegisterDatabaseLocal ~ type:', type)

        const index = getIndexForm(selectedForm._id)

        if (type == 'pending') {
            // Caso: hay envío pendiente, solo recargar UI
            onClickForm(index, true) //setear setContents con formsData
        } else if (type == 'reload') {
            console.log('📝 WISE: Creando nuevo registro vacío después de enviar formulario')
            
            try {
                // ✅ FIX WISE: Hacer INSERT directo para evitar confusión con saveFormAnswers
                // saveFormAnswers puede encontrar registros existentes y actualizarlos en lugar de crear nuevos
                const db = await getDb()
                const dateNow = new Date().toISOString()
                const dayUniqueId = dateNow.split('T')[0].substring(2).replace(/-/g, '') // YYMMDD

                const insertSql = `
                    INSERT INTO form_question_answers (
                        repeat,
                        date_init,
                        date_finish,
                        schedule_id,
                        form_id,
                        store_id,
                        status,
                        answers,
                        questions,
                        progress,
                        totalScore,
                        scoreObtainedFloat,
                        cant_questions_yes_na,
                        progress_questions_yes_na,
                        scoreTotalQuestionsPonderarFloat,
                        name_form,
                        heladera,
                        create_refrigerator,
                        type_form,
                        form_id_father,
                        checkout,
                        day_unique_id,
                        checkin_id
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
                `

                const insertParams = [
                    1, // repeat
                    dateNow, // date_init
                    null, // date_finish
                    'wise', // schedule_id
                    selectedForm._id, // form_id
                    '', // store_id
                    0, // status = PENDING
                    '[]', // answers = VACÍO
                    JSON.stringify(selectedForm.contents || []), // questions
                    0, // progress
                    0, // totalScore
                    0, // scoreObtainedFloat
                    0, // cant_questions_yes_na
                    0, // progress_questions_yes_na
                    0, // scoreTotalQuestionsPonderarFloat
                    selectedForm.name_form || 'Auditorías WISE', // name_form
                    0, // heladera
                    0, // create_refrigerator
                    selectedForm.type_form ? JSON.stringify(selectedForm.type_form) : '{}', // type_form
                    '', // form_id_father
                    null, // checkout
                    dayUniqueId, // day_unique_id (solo para registro, WISE no lo usa en queries)
                    '', // checkin_id
                ]

                await db.run({
                    sql: insertSql,
                    params: insertParams,
                })

                console.log('✅ WISE: Nuevo registro vacío insertado directamente en BD')
            } catch (error) {
                console.error('❌ WISE: Error creando nuevo registro vacío:', error)
            }
            
            // ✅ FIX WISE: Limpiar day_unique_id del store para que el próximo registro tenga uno nuevo
            clearFormDayUniqueId(selectedForm._id, 'wise', null)
            
            setFormReloadKey((prev) => prev + 1)
            onClickForm(index, true)
            console.log('✅ WISE: Nuevo registro limpio listo para usar')
        } else {
            try {
                const dayId = getOrCreateFormDayUniqueId(selectedForm._id, 'wise', null)
                await schedulesServices.deleteFormAnswer('wise', selectedForm._id, null, dayId)
                
                // ✅ FIX WISE: Limpiar day_unique_id después de eliminar
                clearFormDayUniqueId(selectedForm._id, 'wise', null)
            } catch (err) {
                console.log('ℹ️ WISE: no se pudo eliminar registro previo:', err)
            }
            onClickForm(index, true)
        }
    }

    const getIndexForm = (form_id: string) => {
        const index = formsData.findIndex((form: Wise) => form._id === form_id)
        return index === -1 ? 0 : index
    }

    return (
        <>
            {isLoading ? (
                <View style={styles.container}>
                    <Loader />
                </View>
            ) : modalRetry ? (
                <RetryComponent onRefresh={fetchGetWise} textButton='Reintentar' title='No pudimos cargar los formularios' />
            ) : formsData.length === 0 ? (
                <RetryComponent onRefresh={fetchGetWise} textButton='Reintentar' title='No hay formularios disponibles' />
            ) : (
                <View style={styles.container}>
                        <View style={styles.containerFilters}>
                            <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={styles.scrollView}>
                                <View style={styles.containerFormItem}>
                                    {formsData.map((form, index) => {
                                        const isSelected = selectedForm === form
                                        const image = isSelected ? form?.icon_check : form?.icon

                                        return (
                                            <StoreFormItem
                                                key={form?._id + index}
                                                name={form?.name_form}
                                                image={image}
                                                index={index}
                                                onClickItem={onClickForm}
                                                isSelected={isSelected}
                                            />
                                        )
                                    })}
                                </View>
                            </ScrollView>
                        </View>

                        {(() => {
                            switch (formType) {
                                case 19:
                                case 13:
                                    // return formContent.length > 0 && <FormView formContent={formContent} hideOrShow={hideOrShow} form_id={selectedForm?._id} />
                                    return (
                                        <>
                                            {formContent.length > 0 && (
                                                <FormView
                                                    key={`${selectedForm?._id}-${formReloadKey}`}
                                                    formContent={formContent}
                                                    hideOrShow={hideOrShow}
                                                    form_id={selectedForm?._id}
                                                    schedule_id={'wise'}
                                                    repeat={selectedForm?.repeat}
                                                    progress={selectedForm?.progress}
                                                    totalScore={selectedForm?.totalScore}
                                                    clearRegisterDatabaseLocal={clearRegisterDatabaseLocal}
                                                    hasFinishSheet={true}
                                                    reloadHideShowData={reloadHideShowData}
                                                    tags={[]}
                                                    onClickTag={() => {}}
                                                    formType={formType}
                                                    name_form={selectedForm?.name_form}
                                                    formTypeObj={formTypeObj}
                                                    // getStatusForm={getStatusForm}
                                                />
                                            )}
                                        </>
                                    )
                                default:
                                    return (
                                        <>
                                            <View style={styles.containerNoMessage}>
                                                <Image style={styles.imageNoMessage} source={require('../../../assets/noFormSelected.png')} />
                                                <Text style={styles.titleNoMessage}>{languageFile.select_form}</Text>
                                                <Text style={styles.descriptionNoMessage}>{languageFile.select_one_form}</Text>
                                            </View>
                                        </>
                                    )
                            }
                        })()}
                </View>
            )}
        </>
    )
})
